import React from 'react';

const KE = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_123"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_123)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V11H0V10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11H21V15H0V11Z"
        fill="#006700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5H21V10H0V5Z"
        fill="#BD0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H21V5H0V4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.414 5.914C12.486 5.914 12.914 5.244 12.914 4.414C12.914 3.586 12.486 2.914 12.414 2.914C12.344 2.914 11.914 3.586 11.914 4.414C11.914 5.244 12.344 5.914 12.414 5.914ZM9.47499 5.475C9.42499 5.525 8.64499 5.355 8.06099 4.768C7.47599 4.182 7.30399 3.404 7.35499 3.354C7.40499 3.304 8.18299 3.474 8.76899 4.061C9.35499 4.647 9.52599 5.425 9.47599 5.476L9.47499 5.475ZM11.354 10.008C11.404 9.961 12.184 10.121 12.769 10.668C13.354 11.218 13.526 11.945 13.476 11.992C13.426 12.039 12.646 11.879 12.06 11.332C11.475 10.782 11.303 10.055 11.354 10.008ZM9.47499 10.008C9.42499 9.961 8.64499 10.121 8.06099 10.668C7.47599 11.218 7.30399 11.945 7.35499 11.992C7.40499 12.039 8.18299 11.879 8.76899 11.332C9.35499 10.782 9.52599 10.055 9.47599 10.008H9.47499Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 12C10.857 12 13 9.985 13 7.5C13 5.015 10.857 3 10.5 3C10.143 3 8 5.015 8 7.5C8 9.985 10.143 12 10.5 12Z"
        fill="#BD0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 9C8.57 9 9 8.328 9 7.5C9 6.672 8.57 6 8.5 6C8.43 6 8 6.672 8 7.5C8 8.328 8.43 9 8.5 9ZM12.5 9C12.57 9 13 8.328 13 7.5C13 6.672 12.57 6 12.5 6C12.43 6 12 6.672 12 7.5C12 8.328 12.43 9 12.5 9Z"
        fill="black"
      />
      <path
        d="M11 7.5C11 6.67157 10.7761 6 10.5 6C10.2239 6 10 6.67157 10 7.5C10 8.32843 10.2239 9 10.5 9C10.7761 9 11 8.32843 11 7.5Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default KE;
